import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, hexToRgbaWithAlpha } from '../theme';

export const useAccountsPickerStyles = createStyles(({ token }) => {
  const titleSubtitleBase = {
    lineHeight: '30px',
    fontFamily: ThemeFont.FONT_CONDENSED,
    color: ThemeColors.COLOR_GREY_BLUISH8,
  };

  return {
    widget: {
      backgroundColor: ThemeColors.COLOR_GREY_DARK1_3,
      border: `1px solid ${ThemeColors.COLOR_GREY_DARK3}`,
      boxShadow: `0 4px 30px ${hexToRgbaWithAlpha(
        ThemeColors.COLOR_BLACK1_5,
        0.5
      )}`,
      borderRadius: token.borderRadius,

      '.ant-checkbox': {
        marginRight: 10,
      },
      '.ant-checkbox-wrapper': {
        '&, &.ant-checkbox-wrapper-checked': {
          color: ThemeColors.COLOR_GREY_BLUISH3_2,
          fontWeight: 400,
          fontSize: 14,
        },
        lineHeight: '40px',
        marginLeft: 10,
      },
    },
    searchInput: {
      flexGrow: 1,
      marginRight: 20,
    },
    accountsPickerNoItems: {
      color: ThemeColors.COLOR_GREY_BLUISH3_2,
      padding: 10,
      borderTop: `1px solid ${ThemeColors.COLOR_GREY3_5}`,
    },
    accountsPickerEditBody: {
      borderTop: `1px solid ${ThemeColors.COLOR_GREY3_5}`,
    },
    accountsPickerTitle: {
      ...titleSubtitleBase,
      backgroundColor: ThemeColors.COLOR_GREY_DARK3,
      fontSize: 14,
      fontWeight: 'bold',
      padding: '0 5px',
      borderBottom: `1px solid ${ThemeColors.COLOR_BLACK2}`,
    },
    accountsPickerSubtitle: {
      ...titleSubtitleBase,
      fontSize: 13,
      fontWeight: 400,
      backgroundColor: ThemeColors.COLOR_GREY_DARK2_7,
      paddingLeft: 20,
      borderTop: `1px solid ${ThemeColors.COLOR_GREY3_5}`,
      borderBottom: `1px solid ${ThemeColors.COLOR_BLACK2}`,
    },
    accountsPickerIcon: {
      padding: '0 5px 0 10px',
    },
    accountsPickerBody: {
      padding: 20,
    },
    accountsPickerItem: {
      color: ThemeColors.COLOR_ORANGE3,
      padding: 10,
      fontFamily: token.fontFamily,
      fontSize: 14,
      fontWeight: 400,
      backgroundColor: ThemeColors.COLOR_GREY_DARK3,
      borderRadius: token.borderRadius,

      '& + &': {
        marginTop: 20,
      },
    },
    accountsPickerEditHeader: {
      backgroundColor: ThemeColors.COLOR_GREY_DARK2_7,
      padding: '15px 10px',
      borderTop: `1px solid ${ThemeColors.COLOR_GREY3_5}`,
      borderBottom: `1px solid ${ThemeColors.COLOR_BLACK2}`,
    },
  };
});
